import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import Container from 'partials/Container';
import GradeConfigurator from './GradeConfigurator';
import AditionalPoints from './AditionalPoints';
import PointsTracker from './PointsTracker';
import Summary from './Summary';
import AnimateIn from 'partials/AnimateIn';

class Calculator extends Component {

    render() {
        const { summaryVisible } = this.props;

        return (
            <Wrapper>
                <AnimateIn>
                    <Container>
                        <AditionalPoints />
                        <GradeConfigurator />
                    </Container>
                    {summaryVisible && <Summary />}
                </AnimateIn>
                <PointsTracker />
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    summaryVisible: state.calculator.summaryVisible
});

export default connect(mapStateToProps, null)(Calculator);

const Wrapper = styled.div`
    margin-bottom:0px;
    @media (max-width: 768px) {
        margin-bottom:0px;
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/Calculator/Calculator.js